import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	searchedUsers: [],
	existingContacts: [],
	allContacts: [],
	selectedContact: {},
	selectedEstContact: {},
	selectedEstUser: {},
	isNewUserMode: true,
	isNewUserOpen: false,
	searchKeyword: '',
};

const userMgtSlice = createSlice({
	name: 'userMgt',
	initialState,
	reducers: {
		storeSearchedUsers: (state, action) => {
			state.searchedUsers = action.payload;
		},
		storeExistingContacts: (state, action) => {
			state.existingContacts = action.payload;
		},
		storeSelectedContact: (state, action) => {
			state.selectedContact = action.payload;
		},
		storeSelectedEstContact: (state, action) => {
			state.selectedEstContact = action.payload;
		},
		storeAllContacts: (state, action) => {
			state.allContacts = action.payload;
		},
		storeSelectedEstUser: (state, action) => {
			state.selectedEstUser = action.payload;
		},
		storeSearchKeyword: (state, action) => {
			state.searchKeyword = action.payload;
		},
		handleIsNewUserMode: (state, action) => {
			state.isNewUserMode = action.payload;
		},
		handleIsNewUserOpen: (state, action) => {
			state.isNewUserOpen = action.payload;
		},
		resetExistingContacts: (state) => {
			state.existingContacts = [];
		},
		resetSelectedEstContact: (state) => {
			state.selectedEstContact = {};
		},
		resetSelectedEstUser: (state) => {
			state.selectedEstUser = {};
		},
	},
});

export const selectAllSearchedUsers = (state) => {
	return state.userMgt.searchedUsers;
};

export const selectAllExistingContacts = (state) => {
	return state.userMgt.existingContacts;
};

export const selectSelectedContact = (state) => {
	return state.userMgt.selectedContact;
};

export const selectSelectedEstContact = (state) => {
	return state.userMgt.selectedEstContact;
};

export const selectAllContacts = (state) => {
	return state.userMgt.allContacts;
};

export const selectSelectedEstUser = (state) => {
	return state.userMgt.selectedEstUser;
};

export const selectIsNewUserMode = (state) => {
	return state.userMgt.isNewUserMode;
};

export const selectIsNewUserOpen = (state) => {
	return state.userMgt.isNewUserOpen;
};

export const selectSearchKeyword = (state) => {
	return state.userMgt.searchKeyword;
};

export const {
	storeSearchedUsers,
	storeExistingContacts,
	storeSelectedContact,
	storeSelectedEstContact,
	storeAllContacts,
	storeSelectedEstUser,
	storeSearchKeyword,
	handleIsNewUserMode,
	handleIsNewUserOpen,
	resetExistingContacts,
	resetSelectedEstContact,
	resetSelectedEstUser,
} = userMgtSlice.actions;

export default userMgtSlice.reducer;
